import { Flex, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const PurchaseCardPriceSectionWrapper = styled(Flex)`
  margin-top: ${Spacing.S24};
`

export const PricePeriodWrapper = styled.div`
  margin-bottom: ${Spacing.S24};
`

export const PriceWrapper = styled.div`
  width: 100%;
  height: 50px;
`
